var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchCompanyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3201_73760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13525 15.8925H6.85673V12.4373H9.44359V15.8925H14.1651V0.407471H2.13525V15.8925ZM10.728 2.12602H12.4465V3.84456H10.728V2.12602ZM10.728 5.56311H12.4465V7.28165H10.728V5.56311ZM10.728 9.0002H12.4465V10.7187H10.728V9.0002ZM7.29089 2.12602H9.00944V3.84456H7.29089V2.12602ZM7.29089 5.56311H9.00944V7.28165H7.29089V5.56311ZM7.29089 9.0002H9.00944V10.7187H7.29089V9.0002ZM3.8538 2.12602H5.57234V3.84456H3.8538V2.12602ZM3.8538 5.56311H5.57234V7.28165H3.8538V5.56311ZM3.8538 9.0002H5.57234V10.7187H3.8538V9.0002Z",
    fill: "#current",
    fillOpacity: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3201_73760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3,
    height: 16.3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCompanyIcon);
export default __webpack_public_path__ + "static/media/SwitchCompanyIcon.84501c451a639b7142aceda6dfa39965.svg";
export { ForwardRef as ReactComponent };